import { Component, inject, Inject } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TrailDocumentCapability } from '../../dto/trail-document-capability';

@Component({
  selector: 'dpi-trail-document-capability-detail',
  imports: [MatInputModule, MatFormFieldModule, FormsModule, MatButtonModule, MatIconModule, MatTooltipModule, MatDialogModule],
  templateUrl: './trail-document-capability-detail.component.html',
  styleUrl: './trail-document-capability-detail.component.scss'
})
export class TrailDocumentCapabilityDetailComponent {
    readonly dialogRef = inject(MatDialogRef<TrailDocumentCapabilityDetailComponent>);
    trailDocumentCapability: TrailDocumentCapability;
    isToUpdate: boolean;
    isToDelete: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: TrailDocumentCapability) {
    this.trailDocumentCapability = data;
    this.isToUpdate = false;
    this.isToDelete = false;
  }
  
  onCancelClick(): void {
    this.dialogRef.close();
  }

  onUpdateClick() {
    this.isToUpdate = true;
  }

  onDeleteClick() {
    this.isToDelete = true;
    this.dialogRef.close();
  }

}
